import { takeEvery, delay, put, call } from "redux-saga/effects";
import { select } from "redux-saga/effects";

import axios from "axios";

import { successLogin, failureLogin } from "./loginAction";
import { handleSetUserDetail } from "../user/userAction";
import loginType from "./loginType";
import {
  cartApi,
  loginApi,
  loginRequestCodeVerificationApi,
  profileApi,
} from "../../../utility/api/apiList";

export const getConstants = (state) => state.constantsDetail;
let cartValue = [];
let isEmptyCart = true;

const getCart = () => {
  if (document.cookie.substring(3) != "") {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; id=`);
    const cookieIdAxios = `?cookieId=${parts.pop().split(";").shift()}`;
    axios.get(`${cartApi}${cookieIdAxios}`).then((response) => {
      let dataArray = [];
      for (let i = 0; i < Object.keys(response.data.data).length; i++) {
        if (response.data.data[0].salespackage.id !== undefined) {
          //personal
          dataArray.push({
            grade: response.data.data[i].grade.id,
            count: 1,
            unitoftime: 0,
            salespackage: response.data.data[i].salespackage.id,
          });
        } else {
          dataArray.push({
            grade: response.data.data[i].grade.id,
            count: response.data.data[i].count,
            unitoftime: response.data.data[i].unitoftime.id,
            salespackage: 0,
          });
        }
      }

      cartValue = {
        cookieId: null,
        data: dataArray,
      };
      isEmptyCart = false;
    });
  } else {
    isEmptyCart = true;
  }
};

const setUserCart = (response) => {
  axios.post(cartApi, cartValue, {
    headers: {
      Authorization: `Bearer ${response.data.data.access}`,
    },
  });
};
const setAxiosDefualt = (response) => {
  axios.defaults.headers["Authorization"] = `Bearer ${response.data.data.access}`;
};

export function* LoginUserByToken(action) {
  const set = yield (axios.defaults.headers[
    "Authorization"
  ] = `Bearer ${action.token}`);

  const profileResponse = yield axios.get(profileApi);
  if (isEmptyCart == false) {
    const setCart = yield axios.post(cartApi, cartValue, {
      headers: { Authorization: `Bearer ${action.token}` },
    });
  }
  const constantsDetail = yield select(getConstants);
  const types = constantsDetail?.constants?.core?.UserMeta?.choices.type;;

  let getRole;
  if (
    constantsDetail?.error == false &&
    constantsDetail?.loading == false &&
    constantsDetail?.constants?.core
  ) {
    let typeArray = [];
    if (types != null || types != undefined) {
      const countType = Object.keys(types).length;
      for (let i = 0, empType; i < countType; i++) {
        empType = types[i];
        typeArray.push({ id: i, name: empType });
      }
    }
    getRole = yield typeArray.find(
      (item) => item.id == profileResponse.data.usermeta.type
    ).name;
  }

  // usertype 2 = teacher
  const userRole =
    profileResponse.data.usermeta.type === 2 ? "teacher" : "student";

  const data = {
    token: action.token,
    details: profileResponse.data,
    role: userRole,
    refresh: action.refresh,
  };

  yield put(handleSetUserDetail(data));
  // const handlesuccess = yield put(successLogin(action.token));

  //  yield call(action.setIsLoadingLoginbtn(false))
  yield delay(10);
  if (action.prevPath) {
    yield (window.location = action.prevPath);
  }else{
    window.location = '/'
  }
}

export function* startLogin(action) {
  let user;
  if (action.password) {
    user = {
      username: action.username,
      password: action.password,
    };
  } else {
    user = {
      username: action.username,
      code: action.code,
      type: 2
    };
  }
  // const mainApi = action.password ? loginApi : loginRequestCodeVerificationApi;
  const mainApi = loginApi;
  try {
    const response = yield axios.post(mainApi, user);
    setAxiosDefualt(response)
    const get = yield call(getCart);
    const setLoginUser = yield put({
      type: loginType.LOGIN_USER_BY_TOKEN,
      token: response.data.data.access,
      refresh: response.data.data.refresh,
      prevPath: action.prevPath,
    });
  } catch (error) {
    console.log( error.response?.data[0]?.details)
    if (error.response.data.non_field_errors) {
      let dataArray = [
        {
          errorMessage: error.response.data.non_field_errors[0],
          errorType: "data",
        },
      ];
      const handlefailed = yield put(failureLogin(dataArray));

      yield delay(3000);
      yield put({ type: loginType.SET_ERROR_FALSE });
    } else if (Array.isArray(error.response.data) && error.response?.data[0]?.details) {

      let dataArray = [
        {
          errorMessage: error.response?.data[0]?.details,
          errorType: "data",
        },
      ];
      const handlefailed = yield put(failureLogin(dataArray));

      yield delay(5000);
      yield put({ type: loginType.SET_ERROR_FALSE });
    }else if (error.response?.data?.details) {

      let dataArray = [
        {
          errorMessage: error.response?.data?.details,
          errorType: "data",
        },
      ];
      const handlefailed = yield put(failureLogin(dataArray));

      yield delay(5000);
      yield put({ type: loginType.SET_ERROR_FALSE });
    } else if (error.response?.data?.invalid) {

      let dataArray = [
        {
          errorMessage: error.response?.data?.invalid,
          errorType: "data",
        },
      ];
      const handlefailed = yield put(failureLogin(dataArray));

      yield delay(5000);
      yield put({ type: loginType.SET_ERROR_FALSE });
    } else if (error.response.data.username) {
      const dataArray = [
        {
          errorMessage: `مقدار نام کاربری نباید خالی باشد !`,
          errorType: "username",
        },
      ];
      const handlefailed = yield put(failureLogin(dataArray));
    } else {
      const dataArray = [
        {
          errorMessage: error.response.data?.code[0],
          errorType: "password",
        },
      ];
      const handlefailed = yield put(failureLogin(dataArray));
    }
  }
}

export function* loginListener() {
  yield takeEvery(loginType.START_LOGIN, startLogin);
}
export function* loginUserByTokenListener() {
  yield takeEvery(loginType.LOGIN_USER_BY_TOKEN, LoginUserByToken);
}
